import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  Table,
  ControlLabel,
  FormControl,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";

import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import {
  getMedicationcategory,
  AddMedication,
  getCity,
  getCountry,
  GetAllSuppliers,
  checkMedication,
  getpagewiseMedicationTag,
  getallmedicationpackages,
  Get_Medication_commision,
  getAllGenericName,
} from "../../../Listfunction";
import Select from "react-select";
import NotificationSystem from "react-notification-system";
import SweetAlert from "react-bootstrap-sweetalert";
import { style } from "../../../variables/Variables";
import axios from "axios";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import MultiValueTextInput from "./MultiValueTextInput";
import { genericNameOptions } from "./medicationUtil";
import { getApiErrorMessage } from "utils/getApiErrorMessage";
class addmedication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      textFields: [],
      status: "1",
      labpackage: [],
      //commision: "1",
      sort_order: "",
      packageItems: [],
      wt_commision: "",
      medicationcategory: [],
      searchTag: null,
      keywordItems: [],
      tagsdetails: [],
      m_category: "0",
      m_categoryError: null,
      description: "",
      descriptionError: null,
      price: "",
      unit_priceError: null,
      item_code: "",
      item_codeError: null,
      unit_price: "",
      selling_price: "",
      quantity: "",
      alert: null,
      barcode: "",
      is_flash_medicine: true,
      is_out_of_stock: false,
      is_cold_item: false,
      cityError: null,
      city: "1",
      codeDisabled: "disabled",
      display_discount: "",
      generic_name: null,
      generic_nameError: null,
      itemname: "",
      itemnameError: null,
      _notificationSystem: null,
      cardHidden: true,
      is_featured: "2",
      is_available: "0",
      tagsdetails: [],
      city_info: [],
      itemcodeunique: "",
      package_image_data: [],
      packageImageError: null,
      package_image: [],
      packageitemdetails: [],
      packageitem: null,
      packageitemoptiondetails: [],
      primaryimage: "",
      errormessages: [],
      suppliersData: [],
      supplier: "",
      tags: [],
      deliver_within: "0",
      deliver_withinError: null,
      quantity_typeError: null,
      quantity_type: "2",
      showPerBox: false,
      quantity_per_box: "0",
      quantity_per_boxError: null,
      medicationpackage: "0",
      setting_commision: "",
      supplier_name: "",
      supplier_nameError: null,
      country_code: "+94",
      mobile_no: "",
      mobile_noError: null,
      supplier_email: "",
      supplier_emailError: null,
      tag: [],
      buyingPriceErrorAlert: null,
      row: "",
      column: "",
      isSubmitting: false,
      isRowError: null,
      isColumnError: null,
      missingRequiredFieldError: null,
      packSize: null,
      route: null,
      dosage: null,
      dosageMedi: null,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.isFalshMedicine = this.isFalshMedicine.bind(this);
    this.item_code_error = React.createRef();
  }

  handleMultiTextField(val) {
    this.setState({ textFields: val, tag: val });
  }

  isFalshMedicine = (e) => {
    var checked = e.target.checked;
    if (checked) {
      this.setState({ codeDisabled: "disabled" });
    } else {
      this.setState({ codeDisabled: "" });
    }
    this.setState({ is_flash_medicine: checked });
  };

  isoutofstock = (e) => {
    var checked = e.target.checked;
    if (checked) {
      this.setState({ codeDisabled: "disabled" });
    } else {
      this.setState({ codeDisabled: "" });
    }
    console.log(checked);
    this.setState({ is_out_of_stock: checked });
  };
  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Medication</b> - Added Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {/* <b>Network Error</b>. */}
          <b>{getApiErrorMessage(error)}</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ supplierValidation: true });

    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );

    Get_Medication_commision(obj).then((res) => {
      if (res.data.success == true) {
        var com = res.data.data;
        this.setState({ setting_commision: com.setting_value });
        this.setState({ settingsloading: false });
      }
    });

    let compelte = 1;
    let pg_no = 1;
    while (compelte == 1) {
      await getMedicationcategory(obj, pg_no).then((response) => {
        const mdata = response.data;
        console.log("mdata", mdata);
        if (mdata.data.length == 0) {
          compelte = 0;
        } else {
          var array1 = this.state.medicationcategory;
          var array2 = array1.concat(mdata.data);
          this.setState({
            medicationcategory: array2,
          });
        }
      });

      pg_no++;
    }

    let compelte1 = 1;
    let pg_no1 = 1;
    while (compelte1 == 1) {
      await getallmedicationpackages(obj, pg_no1).then((response) => {
        console.log(response);
        const mdata = response.data;
        if (mdata.data.length == 0) {
          compelte1 = 0;
        } else {
          var array1 = this.state.labpackage;
          var array2 = array1.concat(mdata.data);
          this.setState({
            labpackage: array2,
          });

          let pcItems = [];
          this.state.labpackage.map((x, i) => {
            pcItems.push({ value: x.id, label: x.package_name });
          });
          this.setState({
            packageItems: pcItems,
          });
        }
      });
      pg_no1++;
    }

    var country_id = "1";
    getCountry(obj, country_id).then((res) => {
      this.setState({ city_info: res.data });
    });

    GetAllSuppliers(obj).then((res) => {
      console.log("suppliers data", res.data.data);
      this.setState({ suppliersData: res.data.data });
    });
    getAllGenericName(obj).then((res) => {
      const genericNameOptions = (res.data || [])
        .filter(Boolean)
        .map((name) => ({ value: name, label: name }));
      this.setState({ genericNameOptions });
    });
  }

  categoryChange = async (value) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ m_category: value });

    if (value === "0") {
      this.setState({
        m_categoryError: (
          <small className="text-danger">
            Medication Category is required.
          </small>
        ),
      });
    } else {
      this.setState({ m_categoryError: null });
    }
    this.setState({ tagsdetails: [] });
    let compelte_hc = 1;
    let hc_pg_no = 1;
    this.setState({
      keywordItems: [],
    });
    while (compelte_hc == 1) {
      var country_id = "1";
      await getpagewiseMedicationTag(hc_pg_no, value, obj).then((res) => {
        const data = res.data.data;

        if (data.length == 0) {
          compelte_hc = 0;
        } else {
          // compelte_hc = 0;
          //     console.log(this.state.tagsdetails, "tags details");
          var array1 = this.state.tagsdetails;
          var array2 = array1.concat(data);

          this.setState({
            tagsdetails: array2,
          });

          let hcItems = [];
          this.state.tagsdetails.map((x, i) => {
            hcItems.push({
              value: x.id,
              label: x.keyword,
            });
          });
          this.setState({
            keywordItems: hcItems,
          });
          // console.log(this.state.keywordItems, "keyword items");
        }
      });
      hc_pg_no++;
    }
  };
  supplierChange = async (value) => {
    this.setState({ supplierValidation: true });
    this.setState({ supplier: value });

    if (value >= 1) {
      this.setState({ supplierValidation: false });
    }
  };

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  hideAlert() {
    this.setState({
      alert: null,
      itemname: "",
      isSubmitting: false,
    });
  }

  handleCommissionChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  handleInputChange = (e) => {
    const { value } = e.target;

    this.setState({ unit_price: value });

    if (value === "") {
      this.setState({
        unit_priceError: (
          <small className="text-danger">Buying Price is required.</small>
        ),
      });
    } else {
      this.setState({ unit_priceError: null });
    }
  };

  confirmSubmit = () => {
    this.setState({ errormessages: [] });
    let error = false;
    if (this.state.itemname.length == 0) {
      error = true;
      this.setState({
        itemnameError: (
          <small className="text-danger">Item Name is required.</small>
        ),
      });
    } else if (this.state.itemname.length > 50) {
      error = true;
      this.setState({
        itemnameError: (
          <small className="text-danger">
            Item Name is must be included 50 letters
          </small>
        ),
      });
    } else {
      this.setState({ itemnameError: null });
    }
    if (this.state.m_category == "0") {
      error = true;
      this.setState({
        m_categoryError: (
          <small className="text-danger">
            Medication Category is required.
          </small>
        ),
      });
    } else {
      this.setState({ m_categoryError: null });
    }
    if (this.state.city == "0") {
      error = true;
      this.setState({
        cityError: <small className="text-danger">City is required.</small>,
      });
    } else {
      this.setState({ cityError: null });
    }
    if (this.state.unit_price.length == 0) {
      error = true;
      this.setState({
        unit_priceError: (
          <small className="text-danger">Buying Price is required.</small>
        ),
      });
    } else {
      this.setState({ unit_priceError: null });
    }
    if (
      this.state.is_flash_medicine === 0 ||
      this.state.is_flash_medicine === ""
    ) {
      if (this.state.item_code.length == 0) {
        error = true;
        this.setState({
          item_codeError: (
            <small className="text-danger">Item Code is required.</small>
          ),
        });
      } else {
        this.setState({ item_codeError: null });
      }
    } else {
      this.setState({ item_codeError: null });
    }

    if (this.state.quantity_type == "0") {
      error = true;
      this.setState({
        quantity_typeError: (
          <small className="text-danger">Quantity Type is required.</small>
        ),
      });
    } else {
      this.setState({ quantity_typeError: null });
    }

    if (this.state.quantity_type == 1) {
      if (this.state.quantity_type == 0) {
        console.log("quantity_type");
        error = true;
        this.setState({
          quantity_typeError: (
            <small className="text-danger">Quantity Type is required.</small>
          ),
        });
      } else {
        this.setState({ quantity_typeError: null });
      }
    } else {
      this.setState({ quantity_per_box: "0" });
    }

    /*
    if (this.state.package_image_data.length == 0) {
      error = true;
      this.setState({
        packageImageError: (
          <small className="text-danger">Package image is required..</small>
        ),
      });
    } else {
      this.setState({ packageImageError: null });
    }
    */
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    //check medication name exists
    var id = "";

    if (!error) {
      var packageimages = this.state.package_image_data;
      console.log(packageimages, "package images");

      /*var commision = "";
      if (this.state.commision == "1") {
        commision = "1";
      } else if (this.state.commision == "2") {
        commision = "0";
      }*/

      var is_featured = "";
      if (this.state.is_featured == "1") {
        is_featured = "1";
      } else if (this.state.is_featured == "2") {
        is_featured = "0";
      }
      var itemCode = "";
      if (this.state.is_flash_medicine) {
        itemCode = "";
      } else {
        itemCode = this.state.item_code;
      }

      var tag = [];
      if (this.state.searchTag == null) {
        tag = "";
      } else {
        this.state.searchTag.map((data) => {
          var array1 = tag;
          var array2 = array1.concat(data.value);
          tag = array2;
        });
      }

      var ismadicineout = "";
      if (this.state.is_out_of_stock) {
        ismadicineout = "1";
      } else {
        ismadicineout = 0;
      }

      const genericNameForSubmit =
        this.state.enterGeneticName &&
        (!this.state.generic_name || this.state.generic_name.trim() === "")
          ? this.state.EnterGenericName
          : this.state.generic_name;

      /*var package_d = [];
      if(this.state.medicationpackage == null)
      {
        package_d = ""
      }
      else
      {
      this.state.medicationpackage.map(data => {
        var array1 = package_d; 
        var array2 =  array1.concat(data.value);
        package_d = array2
      })
    }*/

      AddMedication(
        this.state.itemname,
        this.state.m_category && this.state.m_category.value,
        itemCode,
        //commision,
        this.state.unit_price,
        this.state.city,
        this.state.description,
        is_featured,
        this.state.is_flash_medicine,
        this.state.barcode,
        this.state.quantity,
        this.state.raw,
        this.state.column,
        this.state.display_discount,
        this.state.supplier && this.state.supplier.value,
        this.state.primaryimage,
        packageimages,
        tag,
        this.state.sort_order,
        this.state.generic_name ? this.state.generic_name.value : null,
        this.state.packSize,
        this.state.is_available,
        this.state.selling_price,
        this.state.deliver_within,
        this.state.quantity_type,
        this.state.quantity_per_box,
        ismadicineout,
        this.state.supplier_name,
        this.state.country_code,
        this.state.mobile_no,
        this.state.supplier_email,
        this.state.tag,
        this.state.dosageMedi,
        this.state.dosage,
        this.state.product_categories,
        this.state.route,
        //package_d,
        obj,
        this.state.is_cold_item,
      )
        .then((res) => {
          if (res.data.success === false) {
            let message = res.data.data;
            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({ errormessages: ermessage });
              this.item_code_error.current.focus();
              this.setState({
                item_codeError: (
                  <small className="text-danger">{message.item_code}</small>
                ),
              });
            } else {
              this.handleClick("bl");
            }
          } else if (res.data.success === true) {
            this.handleSuccess("bl");
            this.setState({
              //commision: "1",
              isSubmitting: false,
              m_category: "0",
              description: "",
              itemname: "",
              price: "",
              item_code: "",
              unit_price: "",
              city: "0",
              is_featured: "2",
              is_available: "0",
              is_cold_item: false,
              generic_name: "",
              deliver_within: "",
            });
          }
          // this.props.history.push('/admin/medication');
        })
        .catch((error) => {
          this.handleNetworkError("bl", error);
          console.log(error, "== error");
          this.setState({ isSubmitting: false });
        });
    }
  };
  onSubmit = async () => {
    this.setState({ errormessages: [], missingRequiredFieldError: null });
    let error = false;
    if (this.state.itemname.length == 0) {
      error = true;
      this.setState({
        itemnameError: (
          <small className="text-danger">Item Name is required.</small>
        ),
      });
    } else if (this.state.itemname.length > 50) {
      error = true;
      this.setState({
        itemnameError: (
          <small className="text-danger">
            Item Name is must be included 50 letters
          </small>
        ),
      });
    } else {
      this.setState({ itemnameError: null });
    }
    if (!this.state.row) {
      error = true;
      this.setState({
        isRowError: <small className="text-danger">Row is required.</small>,
      });
    } else {
      this.setState({ isRowError: null });
    }
    if (!this.state.column) {
      error = true;
      this.setState({
        isColumnError: (
          <small className="text-danger">Column is required.</small>
        ),
      });
    } else {
      this.setState({ isColumnError: null });
    }
    if (this.state.m_category == "0") {
      error = true;
      this.setState({
        m_categoryError: (
          <small className="text-danger">
            Medication Category is required.
          </small>
        ),
      });
    } else {
      this.setState({ m_categoryError: null });
    }
    if (this.state.city == "0") {
      error = true;
      this.setState({
        cityError: <small className="text-danger">City is required.</small>,
      });
    } else {
      this.setState({ cityError: null });
    }
    if (this.state.unit_price.length == 0) {
      error = true;
      this.setState({
        unit_priceError: (
          <small className="text-danger">Buying Price is required.</small>
        ),
      });
    } else {
      this.setState({ unit_priceError: null });
    }

    if (
      this.state.is_flash_medicine === 0 ||
      this.state.is_flash_medicine === ""
    ) {
      if (this.state.item_code.length == 0) {
        error = true;
        this.setState({
          item_codeError: (
            <small className="text-danger">Item Code is required.</small>
          ),
        });
      } else {
        this.setState({ item_codeError: null });
      }
    } else {
      this.setState({ item_codeError: null });
    }

    if (this.state.quantity_type == "0") {
      error = true;
      this.setState({
        quantity_typeError: (
          <small className="text-danger">Quantity Type is required.</small>
        ),
      });
    } else {
      this.setState({ quantity_typeError: null });
    }

    if (this.state.quantity_type == 1) {
      if (this.state.quantity_type == 0) {
        error = true;
        this.setState({
          quantity_typeError: (
            <small className="text-danger">Quantity Type is required.</small>
          ),
        });
      } else {
        this.setState({ quantity_typeError: null });
      }
    } else {
      this.setState({ quantity_per_box: "0" });
    }

    if (
      this.state.supplier_name.length > 0 ||
      this.state.mobile_no.length > 0
    ) {
      console.log("edited");
      if (this.state.supplier_name.length == 0) {
        error = true;
        this.setState({
          supplier_nameError: (
            <small className="text-danger">Supplier Name is required.</small>
          ),
        });
      } else {
        this.setState({ supplier_nameError: null });
      }

      if (this.state.mobile_no.length == 0) {
        error = true;
        this.setState({
          mobile_noError: (
            <small className="text-danger">
              Supplier Mobile Number is required.
            </small>
          ),
        });
      } else {
        this.setState({ mobile_noError: null });
      }
      if (this.state.supplier_name.length > 0) {
        if (this.state.mobile_no.length == 0) {
          error = true;
          this.setState({
            mobile_noError: (
              <small className="text-danger">
                Supplier Mobile Number is required.
              </small>
            ),
          });
        } else {
          this.setState({ mobile_noError: null });
        }
      }
    }

    if (Number(this.state.unit_price) >= Number(this.state.selling_price)) {
      error = true;
      this.setState({
        buyingPriceErrorAlert: (
          <small className="text-danger">
            Selling price Must be greater than Unit Price.
          </small>
        ),
      });
    } else {
      this.setState({
        buyingPriceErrorAlert: null,
      });
    }

    /*
    if (this.state.package_image_data.length == 0) {
      error = true;
      this.setState({
        packageImageError: (
          <small className="text-danger">Package image is required..</small>
        ),
      });
    } else {
      this.setState({ packageImageError: null });
    }
       if (error) {
      return;
    }
    */
    if (error) {
      this.setState({
        missingRequiredFieldError: (
          <small className="text-danger">
            Some fields are required. Please fill them.
          </small>
        ),
      });
      return;
    }
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    //check medication name exists
    var id = "";

    await checkMedication(this.state.itemname, id, obj).then((res) => {
      if (res.data.success === false) {
        error = true;
        this.setState({
          alert: (
            <SweetAlert
              warning
              style={{ display: "block", marginTop: "-100px" }}
              title="Are you sure?"
              onConfirm={() => this.confirmSubmit(id)}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
              cancelBtnBsStyle="danger"
              confirmBtnText="Yes, add it!"
              cancelBtnText="Cancel"
              showCancel
            >
              <h4>
                This medication name already exist. Are you sure you want to add
                it!
              </h4>
              {res.data.data.length != 0 && (
                <React.Fragment>
                  <h6>Available Medicine</h6>
                  {res.data.data.map((exdata) => (
                    <p>
                      #{exdata.id} -{exdata.title} - {exdata.item_code}
                    </p>
                  ))}
                </React.Fragment>
              )}
            </SweetAlert>
          ),
        });
      }
    });

    if (!error) {
      var packageimages = this.state.package_image_data;

      /* var commision = "";
      if (this.state.commision == "1") {
        commision = "1";
      } else if (this.state.commision == "2") {
        commision = "0";
      }*/

      var is_featured = "";
      if (this.state.is_featured == "1") {
        is_featured = "1";
      } else if (this.state.is_featured == "2") {
        is_featured = "0";
      }
      var itemCode = "";
      if (this.state.is_flash_medicine) {
        itemCode = "";
      } else {
        itemCode = this.state.item_code;
      }

      var tag = [];
      if (this.state.searchTag == null) {
        tag = "";
      } else {
        this.state.searchTag.map((data) => {
          var array1 = tag;
          var array2 = array1.concat(data.value);
          tag = array2;
        });
      }
      var ismadicineout = "";
      console.log(this.state.is_out_of_stock);
      if (this.state.is_out_of_stock) {
        ismadicineout = "1";
      } else {
        ismadicineout = 0;
      }

      const genericNameForSubmit =
        this.state.enterGeneticName &&
        (!this.state.generic_name || this.state.generic_name.trim() === "")
          ? this.state.EnterGenericName
          : this.state.generic_name;

      /*var package_d = [];
      if(this.state.medicationpackage == null)
      {
        package_d = ""
      }
      else
      {
      this.state.medicationpackage.map(data => {
        var array1 = package_d; 
        var array2 =  array1.concat(data.value);
        package_d = array2
      })
    }**/

      AddMedication(
        this.state.itemname,
        this.state.m_category && this.state.m_category.value,
        itemCode,
        //commision,
        this.state.unit_price,
        this.state.city,
        this.state.description,
        is_featured,
        this.state.is_flash_medicine,
        this.state.barcode,
        this.state.quantity,
        this.state.row,
        this.state.column,
        this.state.display_discount,
        this.state.supplier.value,
        this.state.primaryimage,
        packageimages,
        tag,
        this.state.sort_order,
        this.state.generic_name ? this.state.generic_name.value : null,
        this.state.packSize,
        this.state.is_available,
        this.state.selling_price,
        this.state.deliver_within,
        this.state.quantity_type,
        this.state.quantity_per_box,
        ismadicineout,
        this.state.supplier_name,
        this.state.country_code,
        this.state.mobile_no,
        this.state.supplier_email,
        this.state.tag,
        this.state.dosageMedi,
        this.state.dosage,
        this.state.product_categories,
        this.state.route,
        //package_d,
        obj,
        this.state.is_cold_item,
      )
        .then((res) => {
          if (res.data.success === false) {
            let message = res.data.data;
            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({ errormessages: ermessage });
              this.item_code_error.current.focus();
              this.setState({
                item_codeError: (
                  <small className="text-danger">{message.item_code}</small>
                ),
              });
            } else {
              this.handleClick("bl");
            }
          } else if (res.data.success === true) {
            this.handleSuccess("bl");
            this.setState({
              //commision: "1",
              isSubmitting: false,
              m_category: "0",
              description: "",
              itemname: "",
              price: "",
              item_code: "",
              unit_price: "",
              city: "0",
              is_featured: "2",
              is_available: "",
              is_cold_item: false,
              generic_name: null,
              deliver_within: "",
            });
          }
          this.props.history.push("/admin/medication");
          this.setState({ isSubmitting: false });
        })
        .catch((error) => {
          this.handleNetworkError("bl", error);
          this.setState({ isSubmitting: false });
          console.log(error, "== error");
        });
    }
  };
  upload() {
    document.getElementById("selectImage").click();
  }
  handleFileChange = async (event) => {
    let data = [];

    data.push(event.target.files);

    this.setState({ package_image: data });

    var packageimages = "";
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    if (data.length != 0) {
      this.setState({ processing: true });

      const fdata = new FormData();

      data.map((file) => {
        for (var i = 0; i < file.length; i++) {
          fdata.append("image_file[]", file[i]);
          console.log(file[i], "in file");
        }
      });

      let url = process.env.REACT_APP_NOT_SECRET_CODE + "/subscriptions/image";
      await axios
        .post(url, fdata, {
          headers: {
            Authorization: "Bearer " + obj,
            "X-Country-Code": "BD",
            "X-Client-Name": "WEBSITE",
            "X-Client-Version": "123",
            "Content-Type": "application/json",
            "X-Request-Id": "124",
          },
        })
        .then((res) => {
          console.log(res, "res for package image");
          packageimages = res.data.data.image_url;
          this.setState({ package_image_data: packageimages });
          // priscription_array_data.push(priscription_data);
        });
    }
  };
  handleChange(tags) {
    this.setState({ tags });
  }

  handleQuantity_per_box_chnage(event) {
    this.setState({ quantity_per_box: event.target.value });
    event.target.value === ""
      ? this.setState({
          quantity_per_boxError: (
            <small className="text-danger">Quantity per box is required.</small>
          ),
        })
      : this.setState({ type_textError: null });
  }

  // handleQuantity_type_chnage(event) {
  //   this.setState({ quantity_type: event.target.value });
  //   if (event.target.value == 1) {
  //     this.setState({ showPerBox: true });
  //   } else {
  //     this.setState({ quantity_per_box: "0" });
  //     this.setState({ showPerBox: false });
  //   }

  //   event.target.value === "0"
  //     ? this.setState({
  //         quantity_typeError: (
  //           <small className="text-danger">Quantity Type is required.</small>
  //         ),
  //       })
  //     : this.setState({ quantity_typeError: null });
  // }

  render() {
    const { textFields } = this.state;
    const genericNameOptions = this.state.genericNameOptions || [];
    const medicaioncat = this.state.medicationcategory;
    const city_info = this.state.city_info;
    const itemcodeunique = this.state.itemcodeunique;
    const errormessages = this.state.errormessages;
    const dosageOptions = [
      "mg",
      "g",
      "mcg",
      "ml",
      "mg/ml",
      "mg/5 ml",
      "%",
      "IU",
      "IU/ml",
      "mcg/dose",
      "mg/dose",
      "mg/g",
    ].map((item) => ({ value: item, label: item }));

    return (
      <div className="main-content">
        <input
          style={{ width: "0px", height: "0px", border: "none" }}
          type="text"
          ref={this.item_code_error}
        />
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />
          {this.state.alert}
          <Row>
            <Col md={12}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                    <FormGroup>
                      <Checkbox
                        number="49"
                        checked={this.state.is_flash_medicine}
                        onChange={(e) => this.isFalshMedicine(e)}
                        label="Is Flash Medicine / Product?"
                      ></Checkbox>
                    </FormGroup>
                    {this.state.is_flash_medicine && (
                      <FormGroup>
                        <ControlLabel>Supplier</ControlLabel>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          placeholder="Select Supplier"
                          name="supplier"
                          onChange={(value) => this.supplierChange(value)}
                          options={this.state.suppliersData.map((cus) => ({
                            value: cus.id,
                            label: cus.name,
                          }))}
                        />
                        {/* <select
                          className="react-select primary form-control"
                          name="supplier"
                          value={this.state.supplier}
                          // onChange={(event) => {
                          //   this.setState({ supplier: event.target.value });
                          // }}
                          onChange={this.supplierChange}
                        >
                          <option value="0">Select Supplier</option>
                          {this.state.suppliersData.map((cus) => (
                            <option value={cus.id}>{cus.name}</option>
                          ))}
                        </select> */}
                      </FormGroup>
                    )}
                    <FormGroup>
                      <ControlLabel>Product Categories</ControlLabel>
                      <select
                        name="source"
                        onChange={(event) => {
                          this.setState({
                            product_categories: event.target.value,
                          });
                        }}
                        value={this.state.product_categories}
                        className="form-control"
                        placeholder="product Categories"
                      >
                        <option value="">Select Product Categories</option>
                        <option value="Medicine">Medicine</option>
                        <option value="Hygiene">Hygiene</option>
                        <option value="Safety">Safety</option>
                        <option value="Medical Device">Medical Device</option>
                        <option value="Surgical Item">Surgical Item</option>
                        <option value="FMCG">FMCG</option>
                        <option value="Supplement">Supplement</option>
                        <option value="Herbal">Herbal</option>
                        <option value="Retail Item">Retail Item</option>
                      </select>
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Item Code</ControlLabel>
                      <FormControl
                        name="item_code"
                        value={this.state.item_code}
                        disabled={this.state.codeDisabled}
                        onChange={(event) => {
                          this.setState({ item_code: event.target.value });
                          ((this.state.is_flash_medicine === 0) &
                            event.target.value) ===
                          ""
                            ? this.setState({
                                item_codeError: (
                                  <small className="text-danger">
                                    ItemCode is required.
                                  </small>
                                ),
                              })
                            : this.setState({ item_codeError: null });
                        }}
                        placeholder="Enter ItemCode"
                      />
                      {this.state.item_codeError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Item / Brand Name</ControlLabel>
                      <FormControl
                        name="itemname"
                        value={this.state.itemname}
                        onChange={(event) => {
                          this.setState({ itemname: event.target.value });
                          event.target.value === ""
                            ? this.setState({
                                itemnameError: (
                                  <small className="text-danger">
                                    Item Name is must be included 50 letters.
                                  </small>
                                ),
                              })
                            : this.setState({ itemnameError: null });
                        }}
                        placeholder="Enter Item Name"
                        type="text"
                      />
                      {this.state.itemnameError}
                    </FormGroup>
                    {/* <Row>
                      <Col md={4}>
                        <FormGroup>
                          <ControlLabel>Dosage</ControlLabel>
                          <FormControl
                            name="dosageMedi"
                            value={this.state.dosageMedi}
                            onChange={(event) => {
                              this.setState({
                                dosageMedi: event.target.value,
                              });
                            }}
                            onWheel={(e) => e.target.blur()}
                            placeholder="Enter Dosage"
                            type="number"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={2}>
                        <FormGroup style={{ marginTop: "5px" }}>
                          <ControlLabel>Dosage Unit</ControlLabel>
                          <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            name="dosage"
                            options={dosageOptions}
                            value={
                              dosageOptions.find(
                                (option) => option.value === this.state.dosage,
                              ) || null
                            }
                            onChange={(option) => {
                              this.setState({
                                dosage: option ? option.value : "",
                              });
                            }}
                            placeholder="Select Unit"
                            isClearable
                          />
                        </FormGroup>
                      </Col>
                    </Row> */}
                    <FormGroup>
                      <ControlLabel>Route</ControlLabel>
                      <select
                        name="source"
                        onChange={(event) => {
                          this.setState({
                            route: event.target.value,
                          });
                        }}
                        value={this.state.route}
                        className="form-control"
                        placeholder=" Select Route"
                      >
                        <option value="">Select Route</option>
                        <option value="Oral (PO) – by mouth (tablets, syrups)">
                          Oral (PO) – by mouth (tablets, syrups)
                        </option>
                        <option value="Sublingual / Buccal – under the tongue or inside cheek">
                          Sublingual / Buccal – under the tongue or inside cheek
                        </option>
                        <option value="Topical – on the skin (creams, ointments)">
                          Topical – on the skin (creams, ointments)
                        </option>
                        <option value="Transdermal – patch on skin (slow release)">
                          Transdermal – patch on skin (slow release)
                        </option>
                        <option value="Inhalation – breathed in (inhalers, nebulizers)">
                          Inhalation – breathed in (inhalers, nebulizers)
                        </option>
                        <option value="Injection">Injection</option>
                        <option value="IV – into vein">IV – into vein</option>
                        <option value="IM – into muscle">
                          IM – into muscle
                        </option>
                        <option value="SC – under skin">SC – under skin</option>
                        <option value="ID – into skin">ID – into skin</option>
                        <option value="Rectal – suppositories">
                          Rectal – suppositories
                        </option>
                        <option value="Vaginal – pessaries, creams">
                          Vaginal – pessaries, creams
                        </option>
                        <option value="Nasal – nose drops/sprays">
                          Nasal – nose drops/sprays
                        </option>
                        <option value="Ophthalmic – eye drops">
                          Ophthalmic – eye drops
                        </option>
                        <option value="Otic – ear drops">
                          Otic – ear drops
                        </option>
                      </select>
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Generic Name</ControlLabel>
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        placeholder="Select Generic Name"
                        name="generic_name"
                        value={this.state.generic_name}
                        onChange={(value) => {
                          console.log(value);
                          this.setState({
                            generic_name: value,
                          });
                        }}
                        options={genericNameOptions}
                      />
                      {this.state.generic_nameError}
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Pack Size (Per Box)</ControlLabel>
                      <FormControl
                        name="packSize"
                        value={this.state.packSize}
                        onChange={(event) => {
                          this.setState({ packSize: event.target.value });
                        }}
                        placeholder="Enter pack size "
                        type="number"
                        onWheel={(e) => e.target.blur()}
                      />
                      {this.state.packSizeError}
                    </FormGroup>
                    <Row>
                      <Col md={4}>
                        <FormGroup>
                          <ControlLabel>Dosage</ControlLabel>
                          <FormControl
                            name="dosageMedi"
                            value={this.state.dosageMedi}
                            onChange={(event) => {
                              this.setState({
                                dosageMedi: event.target.value,
                              });
                            }}
                            onWheel={(e) => e.target.blur()}
                            placeholder="Enter Dosage"
                            type="number"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={2}>
                        <FormGroup style={{ marginTop: "5px" }}>
                          <ControlLabel>Dosage Unit</ControlLabel>
                          <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            name="dosage"
                            options={dosageOptions}
                            value={
                              dosageOptions.find(
                                (option) => option.value === this.state.dosage,
                              ) || null
                            }
                            onChange={(option) => {
                              this.setState({
                                dosage: option ? option.value : "",
                              });
                            }}
                            placeholder="Select Unit"
                            isClearable
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    {/* <FormGroup>
                      <ControlLabel>Route</ControlLabel>
                      <select
                        name="source"
                        onChange={(event) => {
                          this.setState({
                            route: event.target.value,
                          });
                        }}
                        value={this.state.route}
                        className="form-control"
                        placeholder="Select Route"
                      >
                        <option value="">Select Route</option>
                        <option value="Oral (PO) – by mouth (tablets, syrups)">
                          Oral (PO) – by mouth (tablets, syrups)
                        </option>
                        <option value="Sublingual / Buccal – under the tongue or inside cheek">
                          Sublingual / Buccal – under the tongue or inside cheek
                        </option>
                        <option value="Topical – on the skin (creams, ointments)">
                          Topical – on the skin (creams, ointments)
                        </option>
                        <option value="Transdermal – patch on skin (slow release)">
                          Transdermal – patch on skin (slow release)
                        </option>
                        <option value="Inhalation – breathed in (inhalers, nebulizers)">
                          Inhalation – breathed in (inhalers, nebulizers)
                        </option>
                        <option value="Injection">Injection</option>
                        <option value="IV – into vein">IV – into vein</option>
                        <option value="IM – into muscle">
                          IM – into muscle
                        </option>
                        <option value="SC – under skin">SC – under skin</option>
                        <option value="ID – into skin">ID – into skin</option>
                        <option value="Rectal – suppositories">
                          Rectal – suppositories
                        </option>
                        <option value="Vaginal – pessaries, creams">
                          Vaginal – pessaries, creams
                        </option>
                        <option value="Nasal – nose drops/sprays">
                          Nasal – nose drops/sprays
                        </option>
                        <option value="Ophthalmic – eye drops">
                          Ophthalmic – eye drops
                        </option>
                        <option value="Otic – ear drops">
                          Otic – ear drops
                        </option>
                      </select>
                    </FormGroup> */}
                    <FormGroup>
                      <ControlLabel>Buying price</ControlLabel>
                      <FormControl
                        name="unit_price"
                        value={this.state.unit_price}
                        onChange={(e) => this.handleInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        placeholder="Enter Buying Price"
                        type="number"
                      />
                      {this.state.unit_priceError}
                    </FormGroup>
                    {/*<FormGroup>
                      <ControlLabel>Commision</ControlLabel>
                      <Radio
                        number="5"
                        option="1"
                        name="commision"
                        onChange={(e) => this.handleCommissionChange(e)}
                        checked={this.state.commision === "1"}
                        label="Add"
                      />
                      <Radio
                        number="6"
                        option="2"
                        name="commision"
                        onChange={(e) => this.handleCommissionChange(e)}
                        checked={this.state.commision === "2"}
                        label="Not add"
                      />
                    </FormGroup>*/}
                    <FormGroup>
                      <ControlLabel>
                        Selling Price (Per Item/Tablet)
                      </ControlLabel>
                      <FormControl
                        name="selling_price"
                        value={this.state.selling_price}
                        placeholder="Enter selling Price"
                        onWheel={(e) => e.target.blur()}
                        type="number"
                        onChange={(event) => {
                          this.setState({
                            selling_price: event.target.value,
                          });
                          Number(this.state.unit_price) >=
                          Number(event.target.value)
                            ? this.setState({
                                buyingPriceErrorAlert: (
                                  <small className="text-danger">
                                    Selling price Must be greater than Unit
                                    Price.
                                  </small>
                                ),
                              })
                            : this.setState({ buyingPriceErrorAlert: null });
                        }}
                      />
                      {this.state.buyingPriceErrorAlert}
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Display Discount</ControlLabel>
                      <FormControl
                        name="display_discount"
                        value={this.state.display_discount}
                        onWheel={(e) => e.target.blur()}
                        placeholder="Enter Display Discount"
                        onChange={(e) =>
                          (e.target.value === "" ||
                            (e.target.value >= 1 && e.target.value <= 100)) &&
                          this.setState({ display_discount: e.target.value })
                        }
                        type="number"
                        min="1"
                        max="100"
                      />
                    </FormGroup>
                    {/* {this.category_drop} */}

                    {/* <select
                        className="react-select primary form-control"
                        name="m_category"
                        value={this.state.m_category}
                        onChange={this.categoryChange}
                      >
                        <option value="0">Select Medication Category</option>
                        {medicaioncat.map((cus) => (
                          <option value={cus.id}>{cus.category_name}</option>
                        ))}
                      </select> */}

                    <FormGroup>
                      <ControlLabel>Medication Category</ControlLabel>
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        placeholder="Medication Category"
                        onChange={(value) => this.categoryChange(value)}
                        options={medicaioncat.map((cus) => ({
                          value: cus.id,
                          label: cus.category_name,
                        }))}
                        value={this.state.m_category}
                      />
                      {this.state.m_categoryError}
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Medication Sub-Categories</ControlLabel>
                      {/*<TagsInput
                        value={this.state.tags}
                        onChange={(e) => this.handleChange(e)}
                      /> */}
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        placeholder="Medication Sub-Categories"
                        name="searchTag"
                        closeMenuOnSelect={false}
                        isMulti
                        value={this.state.searchTag}
                        onChange={(value) =>
                          this.setState({
                            searchTag: value,
                          })
                        }
                        options={this.state.keywordItems}
                      />
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Country</ControlLabel>
                      <select
                        className="react-select primary form-control"
                        name="city"
                        value={this.state.city}
                        onChange={(event) => {
                          this.setState({ city: event.target.value });
                          event.target.value === "0"
                            ? this.setState({
                                cityError: (
                                  <small className="text-danger">
                                    Country is required.
                                  </small>
                                ),
                              })
                            : this.setState({ cityError: null });
                        }}
                      >
                        <option value="0">Select Country</option>
                        {city_info.map((cus) => (
                          <option value={cus.id}>{cus.country_name}</option>
                        ))}
                      </select>
                      {this.state.cityError}
                    </FormGroup>

                    {/* <FormGroup>
                      <ControlLabel>Quantity Type</ControlLabel>

                      <div className="order_source_data">
                        <Radio
                          number="31"
                          option="1"
                          name="quantity_type"
                          onChange={(event) =>
                            this.handleQuantity_type_chnage(event)
                          }
                          checked={this.state.quantity_type === "1"}
                          label="Quantiy Per Box"
                        />
                        &nbsp;
                        <Radio
                          number="32"
                          option="2"
                          name="quantity_type"
                          onChange={(event) =>
                            this.handleQuantity_type_chnage(event)
                          }
                          checked={this.state.quantity_type === "2"}
                          label="Quantiy Per Item/Tablet"
                        />
                      </div>
                      {this.state.quantity_typeError}
                    </FormGroup>

                    {this.state.showPerBox == true && (
                      <FormGroup>
                        <ControlLabel>Quantity Per Box</ControlLabel>
                        <FormControl
                          type="text"
                          onChange={(event) =>
                            this.handleQuantity_per_box_chnage(event)
                          }
                          required
                          name="quantity_per_box "
                          value={this.state.quantity_per_box || ""}
                          placeholder="Quantity Per Box"
                        />
                        {this.state.quantity_per_boxError}
                      </FormGroup>
                    )} */}

                    <FormGroup stye={{ display: "none" }}>
                      <ControlLabel>Quantity</ControlLabel>
                      <FormControl
                        name="quantity"
                        value={this.state.quantity}
                        onChange={(e) =>
                          /^\d*$/.test(e.target.value) &&
                          this.setState({ quantity: e.target.value })
                        }
                        onWheel={(e) => e.target.blur()}
                        placeholder="Enter quantity"
                        type="number"
                        min="0"
                        step="1"
                      />
                    </FormGroup>
                    <FormGroup stye={{ display: "none" }}>
                      <ControlLabel>Column</ControlLabel>
                      <FormControl
                        name="column"
                        value={this.state.column}
                        onChange={(event) => {
                          this.setState({
                            column: event.target.value,
                            isColumnError: null,
                          });
                        }}
                        placeholder="Enter column"
                        type="text"
                      />
                      {this.state.isColumnError}
                    </FormGroup>
                    <FormGroup stye={{ display: "none" }}>
                      <ControlLabel>Row</ControlLabel>
                      <FormControl
                        name="row"
                        value={this.state.row}
                        onChange={(event) => {
                          this.setState({
                            row: event.target.value,
                            isRowError: null,
                          });
                        }}
                        placeholder="Enter row"
                        type="text"
                      />
                      {this.state.isRowError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Sort Order</ControlLabel>
                      <FormControl
                        name="sort_order"
                        value={this.state.sort_order}
                        onWheel={(e) => e.target.blur()}
                        placeholder="Enter Sort Order"
                        onChange={(event) => {
                          this.setState({
                            sort_order: event.target.value,
                          });
                        }}
                        type="number"
                      />
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Barcode</ControlLabel>
                      <FormControl
                        name="barcode"
                        value={this.state.barcode}
                        onChange={(event) => {
                          this.setState({ barcode: event.target.value });
                        }}
                        placeholder="Enter Barcode"
                        type="text"
                      />
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Description </ControlLabel>
                      <textarea
                        name="description"
                        value={this.state.description}
                        onChange={(event) => {
                          this.setState({ description: event.target.value });
                        }}
                        placeholder="Enter Description"
                        className="form-control"
                        rows={2}
                        cols={3}
                      ></textarea>
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Delivery within</ControlLabel>
                      <select
                        name="source"
                        onChange={(event) => {
                          this.setState({ deliver_within: event.target.value });
                        }}
                        value={this.state.deliver_within}
                        className="form-control"
                      >
                        <option value="">Select Delivery within</option>
                        <option value="1 - 3 Days">1 - 3 Days</option>
                        <option value="3 - 7 Days">3 - 7 Days</option>
                        <option value="7 - 14 Days">7 - 14 Days</option>
                      </select>
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Images</ControlLabel>
                      <br></br>
                      <input
                        style={{ display: "none" }}
                        id="selectImage"
                        type="file"
                        className="form-control"
                        name="package_image"
                        multiple
                        onChange={this.handleFileChange}
                      />
                      <Button
                        onClick={this.upload}
                        style={{ color: "#2B3A41" }}
                      >
                        {" "}
                        <i
                          className={
                            this.state.package_image == ""
                              ? "fa fa-plus"
                              : "fa fa-pencil fa-fw"
                          }
                        ></i>{" "}
                        {this.state.package_image == ""
                          ? "Choose File"
                          : "Change File"}
                      </Button>
                    </FormGroup>
                    <FormGroup>
                      <Table>
                        <tr>
                          {this.state.package_image_data.map((pid, i) => (
                            <>
                              <td style={{ width: "30px" }}>
                                <Radio
                                  style={{ display: "inline-block" }}
                                  number={"5" + i}
                                  option={pid}
                                  name="primaryimage"
                                  onChange={this.onChange}
                                  //  checked={this.state.eligibility === "1"}
                                  //  label="Web"
                                />
                              </td>
                              <td>
                                <a href={pid} target="_blank">
                                  <img
                                    src={pid}
                                    style={{ height: "30px", width: "30px" }}
                                  ></img>
                                </a>
                              </td>
                            </>
                          ))}
                        </tr>
                      </Table>

                      {this.state.packageImageError}
                    </FormGroup>

                    <FormGroup className="">
                      <ControlLabel>Is Featured ? &nbsp;</ControlLabel>
                      <Radio
                        number="7"
                        option="1"
                        name="is_featured"
                        onChange={this.onChange}
                        checked={this.state.is_featured === "1"}
                        label="Yes"
                      />
                      <Radio
                        number="8"
                        option="2"
                        name="is_featured"
                        onChange={this.onChange}
                        checked={this.state.is_featured === "2"}
                        label="No"
                      />
                    </FormGroup>
                    <FormGroup className="">
                      <ControlLabel>Is Available ? &nbsp;</ControlLabel>
                      <Radio
                        number="11"
                        option="1"
                        name="is_available"
                        onChange={this.onChange}
                        checked={this.state.is_available === "1"}
                        label="avaiable"
                      />
                      <Radio
                        number="12"
                        option="0"
                        name="is_available"
                        onChange={this.onChange}
                        checked={this.state.is_available === "0"}
                        label="unavailable"
                      />
                    </FormGroup>
                    <br />

                    <FormGroup>
                      <Checkbox
                        number="68"
                        checked={this.state.is_out_of_stock}
                        onChange={(e) => this.isoutofstock(e)}
                        label="Is Out of Stock?"
                      ></Checkbox>
                    </FormGroup>
                    <FormGroup>
                      <Checkbox
                        number="69"
                        checked={this.state.is_cold_item}
                        onChange={(e) =>
                          this.setState({ is_cold_item: e.target.checked })
                        }
                        label="This is a cold item"
                      ></Checkbox>
                    </FormGroup>

                    <Row>
                      <Col sm={12} xs={12} md={12}>
                        <div>
                          {this.state.supplierValidation == true ? (
                            <div className="supplier_details_heading_add_medication">
                              <h4
                                style={{
                                  textAlign: "left",
                                  fontWeight: "bold",
                                }}
                              >
                                Supplier Details
                              </h4>
                              <div
                                style={{
                                  marginLeft: "10px",
                                  marginRight: "10px",
                                }}
                              >
                                <Row>
                                  <Col md={6} xs={12} sm={6}>
                                    <FormGroup>
                                      <ControlLabel>Supplier Name</ControlLabel>
                                      <FormControl
                                        name="supplier_name"
                                        value={this.state.supplier_name}
                                        onChange={(event) => {
                                          this.setState({
                                            supplier_name: event.target.value,
                                          });
                                        }}
                                        placeholder="Enter Supplier Name"
                                        type="text"
                                        style={{
                                          width: "98%",
                                          position: "relative",
                                          left: "4px",
                                        }}
                                      />
                                      {this.state.supplier_nameError}
                                    </FormGroup>
                                  </Col>
                                  <Col md={6} xs={12} sm={6}>
                                    <FormGroup>
                                      <ControlLabel>Mobile No</ControlLabel>
                                      <Col md={12}>
                                        <Col
                                          md={2}
                                          className="no-padding"
                                          style={{ marginTop: "4px" }}
                                        >
                                          <select
                                            onChange={this.onChange}
                                            name="country_code"
                                            value={this.state.country_code}
                                            className="form-control"
                                          >
                                            <option value="+94">+94</option>
                                            <option value="+91">+91</option>
                                          </select>
                                        </Col>
                                        <Col md={10}>
                                          <FormControl
                                            type="number"
                                            required
                                            name="mobile_no"
                                            onChange={(event) => {
                                              this.setState({
                                                mobile_no: event.target.value,
                                              });
                                              event.target.value.length < 9 ||
                                              event.target.value.length > 11
                                                ? this.setState({
                                                    mobilenoError: (
                                                      <small className="text-danger">
                                                        Please enter mobile
                                                        nunber from 9 to 11
                                                        digit.
                                                      </small>
                                                    ),
                                                  })
                                                : event.target.value.length == 0
                                                  ? this.setState({
                                                      mobilenoError: null,
                                                      mobile_noError: null,
                                                    })
                                                  : this.setState({
                                                      mobilenoError: null,
                                                      mobile_noError: null,
                                                    });
                                            }}
                                            value={this.state.mobile_no || ""}
                                            placeholder="Supplier Mobile Number"
                                            style={{ width: "460px" }}
                                          />
                                        </Col>
                                        {this.state.mobile_noError}
                                        <br />
                                        {this.state.mobilenoError}
                                      </Col>
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={6} xs={12} sm={6}>
                                    <FormGroup>
                                      <ControlLabel>
                                        Supplier Email
                                      </ControlLabel>
                                      <FormControl
                                        name="supplier_email"
                                        value={this.state.supplier_email}
                                        onChange={(event) => {
                                          this.setState({
                                            supplier_email: event.target.value,
                                          });
                                          event.target.value === ""
                                            ? this.setState({
                                                supplier_emailError: (
                                                  <small className="text-danger">
                                                    Supplier Email is required
                                                  </small>
                                                ),
                                              })
                                            : this.setState({
                                                supplier_emailError: null,
                                              });
                                        }}
                                        placeholder="Enter Supplier Email"
                                        type="text"
                                        style={{
                                          width: "98%",
                                          position: "relative",
                                          left: "4px",
                                        }}
                                      />
                                      {this.state.supplier_emailError}
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </Col>
                    </Row>

                    <FormGroup>
                      <ControlLabel>Tags</ControlLabel>
                      <MultiValueTextInput
                        textFields={textFields}
                        handleMultiTextField={(val) =>
                          this.handleMultiTextField(val)
                        }
                      />
                    </FormGroup>

                    <Button
                      onClick={this.onSubmit.bind(this)}
                      className="btn-color" //bsStyle="info"
                      fill
                      disabled={this.state.isSubmitting}
                    >
                      {this.state.isSubmitting ? "Submitting..." : "Submit"}
                    </Button>
                    <br />
                    {this.state.missingRequiredFieldError
                      ? this.state.missingRequiredFieldError
                      : null}
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default addmedication;
